import { get, keyBy } from 'lodash'
import { CLEANUP_STATE } from '../../actions/shared'

import {
  FETCH_CUSTOMERS_SUCCEEDED,
  FETCH_CUSTOMERS_FAILED,
  SET_ACTIVE_CUSTOMER
} from '../../actions/suites/customer'

const defaultState = { activeCustomerId: null, byId: {}, requestFailed: false }

const reducer = (state = defaultState, action) => {
  switch(action.type) {
    case CLEANUP_STATE: {
      return defaultState
    }

    case FETCH_CUSTOMERS_SUCCEEDED: {
      const customers = get(action.payload, 'data.customers', [])
      const byId = keyBy(customers, 'uuid')

      return {
        ...state,
        byId: byId,
        requestFailed: false,
      }
    }

    case FETCH_CUSTOMERS_FAILED: {
      return {
        ...state,
        requestFailed: true,
      }
    }

    case SET_ACTIVE_CUSTOMER: {
      return {
        ...state,
        activeCustomerId: get(action, 'payload.customerId')
      }
    }

    default:
      return state

  }
}

export default reducer
